import cx from 'classnames';
import { useMemo } from 'react';

export function useVisibilityClasses(hovered: boolean, isMobile: boolean) {
  const animateVisibleClasses = useMemo(
    () =>
      cx('transition-opacity duration-300 ease-in-out', {
        'opacity-0 delay-1000': !hovered && !isMobile,
        'opacity-100': hovered && !isMobile
      }),
    [hovered, isMobile]
  );

  const animateSubtitlePositionClasses = useMemo(
    () =>
      cx('transition-transform duration-300 ease-in-out', {
        'translate-y-5 delay-1000': !hovered && !isMobile,
        'translate-y-0': hovered && !isMobile
      }),
    [hovered, isMobile]
  );

  return {
    animateVisibleClasses,
    animateSubtitlePositionClasses
  };
}
